export const SUBMIT_USOB_SERVICE_REQUESTS_ACTION_REQUESTED =
  "SUBMIT_USOB_SERVICE_REQUESTS_ACTION_REQUESTED";
export const SUBMIT_USOB_SERVICE_REQUESTS_ACTION_DISPATCHER =
  "SUBMIT_USOB_SERVICE_REQUESTS_ACTION_DISPATCHER";
export const SUBMIT_USOB_SERVICE_REQUESTS_ERROR_DISPATCHER =
  "SUBMIT_USOB_SERVICE_REQUESTS_ERROR_DISPATCHER";
export const USOB_SERVICE_REQUESTS_LOADING = "USOB_SERVICE_REQUESTS_LOADING";

//Action Creator
export const submitUSOBServiceRequestsAction = (data, page) => ({
  type: SUBMIT_USOB_SERVICE_REQUESTS_ACTION_REQUESTED,
  postData: data,
  page: page,
});

//Action Dispatcher
export const submitUSOBServiceRequestsActionDispatcher = (data) => {
  let tempData = data?.success?.data;
  // console.log("tempData: ", tempData);
  let tempRegNo = [];
  let tempCustomer = [];
  let tempModelNo = [];
  tempData?.forEach((e) => {
    tempRegNo.push({
      value: e.registration_number_name,
      text: e.registration_number_name,
    });
    tempModelNo.push({ value: e.model_name, text: e.model_name });
    tempCustomer.push({ value: e.owner_name, text: e.owner_name });
  });
  return {
    type: SUBMIT_USOB_SERVICE_REQUESTS_ACTION_DISPATCHER,
    payload: data,
    regNoFilter: [
      ...new Map(tempRegNo.map((item) => [item["value"], item])).values(),
    ],
    modelNoFilter: [
      ...new Map(tempModelNo.map((item) => [item["value"], item])).values(),
    ],
    customerFilter: [
      ...new Map(tempCustomer.map((item) => [item["value"], item])).values(),
    ],
  };
};

export const submitUSOBServiceRequestsErrorDispatcher = (data) => ({
  type: SUBMIT_USOB_SERVICE_REQUESTS_ERROR_DISPATCHER,
  payload: data,
});

export const USOBServiceRequestsLoading = (loading) => ({
  type: USOB_SERVICE_REQUESTS_LOADING,
  payload: loading,
});
